export const getATTPermission = (state) => state.attPermission?.attPermission;
